export default __webpack_public_path__ + "static/get-the-app-hero-59df1129eee750b20e1cd6e817958c81.png";